import PropTypes from 'prop-types';
import React from 'react';

import {useSelector} from 'react-redux';
import {i18n} from 'src/i18n';
import selectors from 'src/modules/recurso/recursoSelectors';
import DrawerButton from 'src/view/shared/view/DrawerButton';
import RecursoView from '../view/RecursoView';

function RecursoListItem(props) {
  const hasPermissionToRead = useSelector(selectors.selectPermissionToRead);

  const valueAsArray = () => {
    const {value} = props;

    if (!value) {
      return [];
    }

    if (Array.isArray(value)) {
      return value;
    }

    return [value];
  };

  const displayableRecord = (record) => {
    return (
      <div key={record.id}>
        <DrawerButton
          drawerId={'DrawerRecursoViewPage'}
          type={'chip'}
          entity={'recurso'}
          tooltipTitle={i18n(record.titulo)}
          buttonTitle={i18n(record.titulo)}
          width={window.innerWidth * 0.55}
          record={record}
          component={<RecursoView record={record} drawer={true} />}
        />
      </div>
    );
  };

  if (!valueAsArray().length) {
    return null;
  }

  return <>{valueAsArray().map((value) => displayableRecord(value))}</>;
}

RecursoListItem.propTypes = {
  value: PropTypes.any,
};

export default RecursoListItem;
